module.exports = __webpack_public_path__ + "img/MOBICAST LOGO FULL COLOR.87e98ba7.png";